import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllClaimStageService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [claimStageSearchQuery, setClaimStageSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(claimStageSearchQuery);

  const allClaimStageService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_STAGES,
      page,
      per_page,
      debouncedQuery,
      ...cacheKeys,
      JSON.stringify(filters),
    ],

    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS?.CLAIM_STAGES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          include: "claims_count",
          ...filters,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    service: { allClaimStageService },
    states: { claimStageSearchQuery, setClaimStageSearchQuery },
  };
};
